import React, { useState } from 'react'
import './toggleButton.scss'

type ToggleButtonProps = {
    toggleText?: string
    onToggle?: (e: React.ChangeEvent<HTMLInputElement>) => void
    className?: string
    defaultValue?: string
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
    toggleText,
    onToggle,
    className,
    defaultValue
}) => {
    const [toggleOn, setToggleOn] = useState<string>(defaultValue ?? 'off')
    const toggleHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onToggle) {
            onToggle(e)
        }
        setToggleOn((prevState) => {
            return prevState === 'off' ? 'on' : 'off'
        })
    }

    return (
        <div
            className={['toggle-parent', `${className}-${toggleOn}`]
                .join(' ')
                .trim()}
        >
            <input
                type="checkbox"
                id="switch"
                className="toggle-input"
                onChange={toggleHandler}
                checked={toggleOn === 'on'}
            />
            <label htmlFor="switch" className="toggle-label">
                <p className="toggle-text">{toggleText}</p>
            </label>
        </div>
    )
}
